<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Personal</h4>
            <p>Administracion del personal de la Unidad</p>        
        </div>
    </div>
    <div class="form-group col-12 col-md-4 offset-md-4">
        <div v-if="cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'OPERADOR RRHH'">
            <label for="capitania boss" >Seleccion Unidad</label>

            <select name="captain_download" class="form-control" id="captain_download" v-model="port_select_pers">
                <option v-for="port in ports_vigency" :value="port" :key="port.id">{{ port.long_detail }} {{ port.name_port }}</option>
            </select>
        </div>
        <div v-else>
            <div class="alert alert-success">{{ cDtsUser.name_port }}</div>
        </div>
        
    </div>  

    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#nav-capitan" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="th-list" /> Listado</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-new-capitan" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="user-plus" /> Agregar</a>
            <a class="nav-item nav-link" id="nav-delete-capitan" data-toggle="tab" href="#nav-del-capitan" role="tab" aria-controls="nav-del" aria-selected="false"><font-awesome-icon icon="user-minus" /> Baja</a>
            <a class="nav-item nav-link" id="nav-delete-capitan" data-toggle="tab" href="#nav-upd-capitan" role="tab" aria-controls="nav-del" aria-selected="false"><font-awesome-icon icon="sync-alt" /> Cambio estado</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="nav-capitan" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br><br>                                    

            <button class="btn btn-outline-primary col-12 col-md-4 offset-md-4" @click="mListPersonsCaptain(0)">
                <font-awesome-icon icon="list" size="2x" /> Listar Personal de la Unidad
            </button>
            <!-- <button class="btn btn-outline-dark col-12 col-md-4">
                <font-awesome-icon icon="file-pdf" size="2x" /> Reporte Capitanes
            </button> -->
            <br><br>
            <div class="col-12 table-responsive-md">
                <transition name="fade" mode="out-in">
                <table class="table table-hover" v-if="persons_captain_list.length > 0">
                    <thead>
                        <tr>
                            <th scope="col" class="table-dark">#</th>
                            <th scope="col" class="table-dark">GRADOS Y NOMBRES</th>
                            <th scope="col" class="table-dark">ESTADO ACTUAL</th>
                            <th scope="col" class="table-dark">TELEFONO</th>
                        </tr>
                    </thead>   
                    <tbody>
                        <tr v-for="(value, index) in persons_captain_list" :key="index">
                            <td>{{ index + 1}}</td>                            
                            <td>{{value.grade}} {{value.especiality}} {{value.complete}}</td>                            
                            <td>{{value.state_current}}</td>
                            <td>{{ value.phone }}</td>
                        </tr>
                    </tbody>
                </table>
                </transition>
            </div>
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="nav-new-capitan" role="tabpanel" aria-labelledby="nav-new-tab">
            <br>
                <div class="alert alert-danger col-12 col-md-6 offset-md-3">
                    Registro del Personal dependiente de la Unidad, NO se debe registrar o dar de alta por esta ventana al capitan de puerto a la Unidad.
                </div>
                <vue-bootstrap-typeahead                            
                    class="col-12 col-md-6 offset-md-3"
                    v-model="persons"
                    :data="persons_list"
                    size="sm"
                    :serializer="item => (`${item.grade} ${item.speciality} ${item.complete} - ${item.identification}`)"
                    @hit="mSelectPerson"
                    :placeholder="'Busqueda de Persona de las Unidades'"                                        
                />
            <div v-if="person_select_captain.id > 0">
                <div class="form-row" >
                        
                    <div class="form-group col-12 col-md-6 offset-md-2">
                        <label for="category_boss">Grado, Nombres y Apellidos</label>
                        <input type="text" readonly class="form-control-plaintext" name="category_boss" v-model="person_select_captain.complete" placeholder="Ejm.: CF. DAEN Pepito Perez" autocomplete="off">
                    </div>
                </div>                                       

                <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" :disabled="is_disabled" @click="mSendNewPersonal">
                    <font-awesome-icon icon="save" size="2x" /> Registrar
                </button>
            </div>
        </div>

        <div class="tab-pane fade" id="nav-del-capitan" role="tabpanel" aria-labelledby="nav-del-tab">
            <br>
            
            <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mListPersonsCaptain(1)">
                <font-awesome-icon icon="list" size="lg" /> Listar Personal Unidad 
            </button>

            <br><br>

            <div class="col-12 table-responsive-md">
                <transition name="fade" mode="out-in">
                <table class="table table-hover" v-if="persons_captain_list_down.length > 0">
                    <thead>
                        <tr>
                            <th scope="col" class="table-dark">#</th>
                            <th scope="col" class="table-dark">Grados y Nombres ({{port_select_pers.name_port}}) </th>
                            <th scope="col" class="table-dark">Baja</th>
                        </tr>
                    </thead>   
                    <tbody>
                        <tr v-for="(value, index) in persons_captain_list_down" :key="index">
                            <td>{{ index + 1}}</td>                            
                            <td>{{value.grade}} {{value.especiality}} {{value.complete}}</td>                            
                            <td v-if="value.order>1"><button class="btn btn-danger" @click="mDownPersons(value)"><font-awesome-icon icon="arrow-circle-down" size="lg" /></button></td>
                            <td v-else><h5>CP</h5></td>
                        </tr>
                    </tbody>
                </table>
                </transition>
            </div>
        </div>

        <div class="tab-pane fade" id="nav-upd-capitan" role="tabpanel" aria-labelledby="nav-del-tab">
            <br>
            
            <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mListPersonsCaptain(1)">
                <font-awesome-icon icon="list" size="lg" /> Lista personal
            </button>

            <br><br>

            <div class="col-12 table-responsive-md">
                <transition name="fade" mode="out-in">
                <table class="table table-hover" v-if="persons_captain_list_down.length > 0">
                    <thead>
                        <tr>
                            <th scope="col" class="table-dark">#</th>
                            <th scope="col" class="table-dark">Grados y Nombres ({{port_select_pers.name_port}}) </th>
                            <th scope="col" class="table-dark">Telefono</th>
                            <th scope="col" class="table-dark">Estado</th>
                            <th scope="col" class="table-dark">----</th>
                        </tr>
                    </thead>   
                    <tbody>
                        <tr v-for="(cap_upd, index) in persons_captain_list_update" :key="index">
                            <td>{{ index + 1}}</td>            
                            <td>{{cap_upd.complete}}</td>
                            <td>{{cap_upd.phone>0 ? cap_upd.phone:'S/R' }}</td>
                            <td>
                                <div v-if="!cap_upd.edit">{{cap_upd.state}}</div>
                                <div v-else class="form-group">
                                    <select name="t_state" class="form-control" :id='`t_state_${index}`' v-model="new_state_personal" >
                                        <option v-for="sl in state_list" :value="sl" :key="sl.id">{{sl.name}}</option>
                                    </select>
                                    <br>
                                    <div class="form-group">
                                        <label for="">Descripcion del cambio</label>
                                        <input type="text" name="" id="" class="form-control" autocomplete="off" v-model="description_change">
                                    </div>
                                </div>
                            </td>
                            
                            <td v-if="!cap_upd.edit">
                                <button class="btn btn-warning" @click="mEditPerson(index)"><font-awesome-icon icon="edit" size="lg" /></button>
                            </td>
                            <td v-else>
                                <button class="btn btn-success" @click="mUpdatePerson(index)"><font-awesome-icon icon="sync-alt" size="lg" /></button>
                                <button class="btn btn-danger" @click="mCancelEdit(index)"><font-awesome-icon icon="times-circle" size="lg" /></button>
                            </td>
                            
                        </tr>
                    </tbody>
                </table>
                </transition>
            </div>
        </div>
    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    data(){
        return{
            capitanList:null,
            ports_vigency:[],
            port_s:null,
            modal_load_id:'loading_port_boss',
            modal_load_title:'Cargando',
            status_send:true,
            port_select:{id:0},
            port_select_pers:{id:0},
            capitan:null,
            date_begin:null,
            telephone:null,
            aux_dn:'DN-0',
            aux_rp:1,
            is_disabled:false,
            header:null,
            config:null,
            persons:null,
            persons_list:[],
            persons_captain_list:[],
            persons_captain_list_down:[],
            persons_captain_list_update:[],
            person_select_captain:{
                id:0
            },
            state_list:[],
            new_state_personal:{},
            description_change:null
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
        this.chargeInit();
    },
    methods:{
        mEditPerson(i){
            this.persons_captain_list_update.forEach(pc=>{
                pc.edit=false;
            })
            this.persons_captain_list_update[i].edit=true;
        },
        mCancelEdit(i){
            this.persons_captain_list_update[i].edit=false;
        },
        mUpdatePerson(i){            
            let new_state_p={};            
            let url=`updatePersonalVigent?api_token=${Vue.auth.getToken()}`;
            if(this.new_state_personal.id>0 && this.persons_captain_list_update[i].state_id !== this.new_state_personal.id){
                new_state_p={
                    id_person:this.persons_captain_list_update[i].id_cap,
                    state_personal:this.new_state_personal.id,
                    description:this.description_change
                }
                let message = {
                    title: `Actualizacion Personal en ${this.port_select_pers.name_port}`,
                    body: `¿Desea actualizar el estado de ${this.persons_captain_list_update[i].complete} de ${this.persons_captain_list_update[i].state} a ${this.new_state_personal.name} ?`
                };
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                });

                npr.then((msg) =>{
                    if(msg){
                        
                    axios.post(url, qs.stringify(new_state_p))
                            .then((data)=>{
                                // console.log(data)
                                if(!data.data[0].error){
                                    toastr.success(data.data[0].response, 'Exito');
                                    this.mListPersonsCaptain(1);
                                    this.description_change=null;
                                }else{
                                    toastr.error(data.data[0].response, 'Error')
                                    
                                }
                            })
                            .catch(err=> {console.log(err); this.is_disabled=false; })
                        }else{
                            console.log('se ha rechazado la actualizacion del personal')
                        }
                        
                    })
                }else{
                    toastr.warning(`Seleccione un nuevo estado para ${this.persons_captain_list_update[i].complete}`, 'Advertencia');
                }            
        },
        mDownPersons(v){            
            
            let url=`downPersonalVigent?api_token=${Vue.auth.getToken()}`;
            let message = {
                title: `Baja Personal en ${this.port_select_pers.name_port}`,
                body: `¿Desea dar de baja al ${v.grade} ${v.especiality} ${v.complete} en la dependencia ${this.port_select_pers.name_port} ?`
            };
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then((msg) =>{
                if(msg){
                    this.is_disabled=true;
                    let new_personal={                        
                        id_person:v.id_pers,
                        _method:'DELETE'
                    }
                    axios.post(url, qs.stringify(new_personal))
                        .then((data)=>{
                            // console.log(data)
                            if(!data.data[0].error){
                                toastr.success(data.data[0].response, 'Exito');
                                this.is_disabled=false;
                                this.person_select_captain.id=0;
                                this.mListPersonsCaptain(1);
                            }else{
                                toastr.error(data.data[0].response, 'Error')
                                this.is_disabled=false;
                            }
                        })
                        .catch(err=> {console.log(err); this.is_disabled=false; })
                    }else{
                        console.log('se ha rechazado la baja del personal')
                    }
                })
            
        },
        async mListPersonsCaptain(t=0){
            this.persons_captain_list=[];            
            // listamos al personal para la baja de personal
            this.persons_captain_list_down=[];
            this.persons_captain_list_update=[];
            if(this.cDtsUser.roleAssign !== 'OPERADOR' && this.cDtsUser.roleAssign !== 'OPERADOR RRHH'){
                if(this.port_select_pers.id===0){
                    toastr.warning('Seleccione una Capitania', 'Advertencia');
                    return false;
                }
            }else{
                this.port_select_pers.id=this.cDtsUser.portId;
                this.port_select_pers.name_port=this.cDtsUser.name_port;
            }

            let url=`getPersonsCaptain/${this.port_select_pers.id}?api_token=${Vue.auth.getToken()}`;
            // let url=`requestCapitan`;
            // aqui listamos el personal de capitanias en el siguiente array
            // this.listPersonsCaptain;
            let lcp=await axios.get(url);
            if(lcp.data.length > 0){
                switch(t){
                    case 0:
                        this.persons_captain_list=lcp.data;            
                    break;

                    case 1:
                        this.persons_captain_list_down=lcp.data;
                        lcp.data.forEach(cpd=>{
                            let aux_cap={
                                id_cap:cpd.id_pers,
                                complete:`${cpd.grade} ${cpd.especiality} ${cpd.complete}`,
                                state:cpd.state_current,
                                state_id:cpd.state,
                                edit:false,
                                phone:cpd.phone
                            }
                            this.persons_captain_list_update.push(aux_cap);
                        })
                    break;
                }
                
            }else{
                toastr.info(`La Unidad ${this.port_select_pers.name_port} no registra personal`, 'Advertencia');
            }
            
            // console.log(this.persons_captain_list);

        },

        async chargeInit(){
            // this.mShowModal(this.modal_load_id);
            
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.ports_vigency=ports.data;
            let tpersonal= await axios.get(`globals/state_per?api_token=${Vue.auth.getToken()}`);

            this.state_list;
            let aux_list=tpersonal.data;
            // console.log(aux_list);
            aux_list.forEach(dp=>{
                if(dp.item!==0){
                    let ts={
                        id:dp.id,
                        name:dp.detail
                    }
                    this.state_list.push(ts);
                }
            })
            setTimeout(()=>{
                this.mHideModal(this.modal_load_id);
            },1000)
        },
        mSendNewPersonal(){
            // console.log(this.port_select.id)
            // let url=`newCapitanPort`;

            let url=`newPersonalCaptain?api_token=${Vue.auth.getToken()}`;
            if( this.mValidateNewPersonalCaptain() ){
                let message = {
                    title: `Registro Personal `,
                    body: `¿Desea registrar a ${this.person_select_captain.charge} en la Dependencia ${this.port_select_pers.name_port} ?`
                };
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

                npr.then((msg) =>{
                    if(msg){
                        this.is_disabled=true;
                        let new_personal={
                            id_port:this.port_select_pers.id,
                            id_person:this.person_select_captain.id,
                            capitan:this.person_select_captain.charge
                        }
                        axios.post(url, qs.stringify(new_personal))
                            .then((data)=>{
                                console.log(data)
                                if(!data.data[0].error){
                                    toastr.success(data.data[0].response, 'Exito');
                                    this.is_disabled=false;
                                    this.person_select_captain.id=0;
                                }else{
                                    toastr.error(data.data[0].response, 'Error')
                                    this.is_disabled=false;
                                }
                            })
                            .catch(err=> {console.log(err); this.is_disabled=false; })
                    }else{

                    }
                })
            }                   
        },
        mValidateNewPersonalCaptain(){
            
            // if(this.capitan===null){
            //     toastr.error('No ha registrado a ningun capitan', 'Error')
            //     return false;    
            // }
            if(this.cDtsUser.roleAssign !== 'OPERADOR' && this.cDtsUser.roleAssign !== 'OPERADOR RRHH'){
                if(this.port_select_pers.id===0){
                    toastr.warning('Seleccione una Capitania', 'Advertencia');
                    return false;
                }
            }else{
                this.port_select_pers.id=this.cDtsUser.portId;
                this.port_select_pers.name_port=this.cDtsUser.name_port;
            }
            
            return true;
        },
        downCapitan(id){
            // let url=`downCapitanVigent/${id}`;
            let url=`downCapitanVigent/${id}?api_token=${Vue.auth.getToken()}`;
            axios.get(url)
            .then( (data) =>{
                if(!data.data[0].error){
                    toastr.success(data.data[0].response, 'Exito');
                    this.capitanDown=null;
                }else{
                    toastr.error(data.data[0].response, 'Error')
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        mShowModal(e){
            $(`#${e}`).modal('show');
        },
        mHideModal(e){
            $(`#${e}`).modal('hide');
        },
        mSelectPerson(data){
            // console.log(data);
            this.person_select_captain.id=data.id;
            this.person_select_captain.complete=`${data.grade} ${data.speciality} ${data.complete}`;
            this.person_select_captain.charge=`${data.grade} ${data.speciality} ${data.complete}`;

        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                // console.log(res);
                this.persons_list=res.data;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    components:{
        'modal-loading':modalLoading
    },
    filters:{
        upCase(value){
            return value.toUpperCase();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/PersonalCaptain.vue